export default "<button type=\"button\" class=\"btn btn-outline-neutral btn-round\" style=\"margin: 5px;\" (click)=\"open()\">Contact Us</button>\n\n"